import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ThemeProvider as SCThemeProvider } from "styled-components";
import { GlobalStyles, GlobalStylesAdmin } from "./GlobalStyles";
import { theme } from "./tokens";
export function ThemeProvider({ children, isAdmin = false }) {
    return (_jsxs(SCThemeProvider, { theme: theme, children: [isAdmin ? _jsx(GlobalStylesAdmin, {}) : _jsx(GlobalStyles, {}), children] }));
}
//# sourceMappingURL=ThemeProvider.js.map